/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { createAction } from '../../utils/redux-utils';
import {
    ActivityDto,
    CashRegisterModelShortDto,
    CityResource,
    FirmwareVersionDTO,
    FiscalDriverVersionDto,
    OperatorShortDto,
    RegionResource,
    StoreTypeResource,
    TaxationTypeDTO,
    TaxAuthorityDTO,
    UserShortDto,
} from '../api/shortLists/shortListsClient.typings';

export enum ShortListsActionType {
    FETCH_CASH_REGISTER_MODELS_LIST_SUCCESS = 'ShortLists/ fetch cash register models list success',
    FETCH_OPERATORS_LIST_SUCCESS = 'ShortLists/ fetch operators list success',
    FETCH_USERS_LIST_SUCCESS = 'ShortLists/ fetch users list success',
    FETCH_STORE_TYPES_LIST_SUCCESS = 'ShortLists/ fetch store types list success',
    FETCH_FIRMWARE_VERSIONS_LIST_SUCCESS = 'ShortLists/ fetch firmware versions list success',
    FETCH_FISCAL_DRIVER_VERSIONS_LIST_SUCCESS = 'ShortLists/ fetch fiscal driver versions list success',
    FETCH_TAX_AUTHORITIES_LIST_SUCCESS = 'ShortLists/ fetch tax authorities list success',
    FETCH_TAXATION_TYPES_LIST_SUCCESS = 'ShortLists/ fetch taxation types list success',
    FETCH_CITIES_LIST_SUCCESS = 'ShortLists/ fetch cities list success',
    FETCH_REGIONS_LIST_SUCCESS = 'ShortLists/ fetch regions list success',
    FETCH_MAIN_ACTIVITIES_LIST_SUCCESS = 'ShortLists/ fetch main activities list success',
    FETCH_MIDDLE_ACTIVITIES_LIST_SUCCESS = 'ShortLists/ fetch middle activities list success',
    FETCH_LOWER_ACTIVITIES_LIST_SUCCESS = 'ShortLists/ fetch lower activities list success',
}

export const fetchCashRegistersSuccessAction = (list: CashRegisterModelShortDto[]) =>
    createAction(ShortListsActionType.FETCH_CASH_REGISTER_MODELS_LIST_SUCCESS, list);

export const fetchOperatorsListSuccessAction = (list: OperatorShortDto[]) =>
    createAction(ShortListsActionType.FETCH_OPERATORS_LIST_SUCCESS, list);

export const fetchUsersListSuccessAction = (users: UserShortDto[]) =>
    createAction(ShortListsActionType.FETCH_USERS_LIST_SUCCESS, users);

export const fetchStoreTypesSuccessActon = (storeTypes: StoreTypeResource[]) =>
    createAction(ShortListsActionType.FETCH_STORE_TYPES_LIST_SUCCESS, storeTypes);

export const fetchFirmwareVersionsListSuccessAction = (list: FirmwareVersionDTO[]) =>
    createAction(ShortListsActionType.FETCH_FIRMWARE_VERSIONS_LIST_SUCCESS, list);

export const fetchFiscalDriverVersionListSuccessAction = (list: FiscalDriverVersionDto[]) =>
    createAction(ShortListsActionType.FETCH_FISCAL_DRIVER_VERSIONS_LIST_SUCCESS, list);

export const fetchTaxAuthoritiesListSuccessAction = (list: TaxAuthorityDTO[]) =>
    createAction(ShortListsActionType.FETCH_TAX_AUTHORITIES_LIST_SUCCESS, list);

export const fetchTaxationTypesListSuccessAction = (list: TaxationTypeDTO[]) =>
    createAction(ShortListsActionType.FETCH_TAXATION_TYPES_LIST_SUCCESS, list);

export const fetchCitiesListSuccessActon = (list: CityResource[]) =>
    createAction(ShortListsActionType.FETCH_CITIES_LIST_SUCCESS, list);

export const fetchRegionsListSuccessActon = (list: RegionResource[]) =>
    createAction(ShortListsActionType.FETCH_REGIONS_LIST_SUCCESS, list);

export const fetchMainActivitiesListSuccessActon = (list: ActivityDto[]) =>
    createAction(ShortListsActionType.FETCH_MAIN_ACTIVITIES_LIST_SUCCESS, list);

export const fetchMiddleActivitiesListSuccessActon = (list: ActivityDto[]) =>
    createAction(ShortListsActionType.FETCH_MIDDLE_ACTIVITIES_LIST_SUCCESS, list);

export const fetchLowerActivitiesListSuccessActon = (list: ActivityDto[]) =>
    createAction(ShortListsActionType.FETCH_LOWER_ACTIVITIES_LIST_SUCCESS, list);

export type ShortListsAction =
    | ReturnType<typeof fetchCashRegistersSuccessAction>
    | ReturnType<typeof fetchOperatorsListSuccessAction>
    | ReturnType<typeof fetchUsersListSuccessAction>
    | ReturnType<typeof fetchStoreTypesSuccessActon>
    | ReturnType<typeof fetchFirmwareVersionsListSuccessAction>
    | ReturnType<typeof fetchFiscalDriverVersionListSuccessAction>
    | ReturnType<typeof fetchTaxAuthoritiesListSuccessAction>
    | ReturnType<typeof fetchTaxationTypesListSuccessAction>
    | ReturnType<typeof fetchCitiesListSuccessActon>
    | ReturnType<typeof fetchRegionsListSuccessActon>
    | ReturnType<typeof fetchMainActivitiesListSuccessActon>
    | ReturnType<typeof fetchMiddleActivitiesListSuccessActon>
    | ReturnType<typeof fetchLowerActivitiesListSuccessActon>;
